import React from 'react';

import { shape } from 'prop-types';

import SchoolinksLogo from 'components/Common/Icons/SchoolinksLogo';
import IconItem from 'components/Common/Layout/components/Icon';
import useModal from 'hooks/useModal';

import s from './HomeItem.css';

const HomeItem = props => {
  const { style, ...restProps } = props;
  const { hideModal } = useModal();
  return (
    <IconItem
      className={s.schooLinksLogo}
      onClick={hideModal}
      style={style}
      {...restProps}
      variant={null}
    >
      <SchoolinksLogo />
    </IconItem>
  );
};

HomeItem.propTypes = {
  style: shape({}),
};

HomeItem.defaultProps = {
  style: {},
};

export default HomeItem;
